/**
 * New strings of the "Traduire" page, FR and EN. Keys that already exist in
 * translations.ts stay in use (t.beginSession, t.phraseXofY, t.french...).
 */
export const transcriptionPhraseCopy = {
  fr: {
    instructions: [
      "Lisez la phrase source en entier avant d'écrire.",
      "Traduisez le sens, pas mot à mot, avec l'orthographe de la langue.",
      "Utilisez le clavier africain pour les caractères propres à la langue.",
      "Votre progression est gardée : vous reprenez là où vous vous étiez arrêté.",
    ],
    resumeTitle: "Reprise de votre session",
    resumeBody: "Elle reprend toute seule dès que la langue est connue.",
    sourceLabel: "À traduire",
    writeLabel: "Votre traduction",
    batchLabel: "Phrases de la page",
    previousPage: "Page précédente",
    nextPage: "Page suivante",
    skip: "Passer cette phrase",
    send: "Envoyer",
    playHint: "lecture / pause",
    keyboardShow: "Afficher le clavier",
    keyboardHide: "Masquer le clavier",
    notProvided: "Non renseigné",
    pageMeta: "Page {page}",
    intoLanguage: "Vers : {language}",
    stepDone: "Traduite",
    emptyTitle: "Aucune phrase à traduire pour l'instant",
    emptyBody: "Revenez plus tard ou choisissez une autre langue.",
    doneDescription: "Il n'y a plus de phrase à traduire dans cette langue pour le moment. Merci pour vos traductions.",
    doneSent: "Traductions envoyées",
    doneBack: "Revenir à la session",
    backToRecording: "Revenir à l'enregistrement",
  },
  en: {
    instructions: [
      "Read the whole source phrase before writing.",
      "Translate the meaning, not word for word, with the language's spelling.",
      "Use the African keyboard for the language's own characters.",
      "Your progress is kept: you pick up where you left off.",
    ],
    resumeTitle: "Resuming your session",
    resumeBody: "It picks up on its own once the language is known.",
    sourceLabel: "To translate",
    writeLabel: "Your translation",
    batchLabel: "Phrases on this page",
    previousPage: "Previous page",
    nextPage: "Next page",
    skip: "Skip this phrase",
    send: "Send",
    playHint: "play / pause",
    keyboardShow: "Show the keyboard",
    keyboardHide: "Hide the keyboard",
    notProvided: "Not provided",
    pageMeta: "Page {page}",
    intoLanguage: "Into: {language}",
    stepDone: "Translated",
    emptyTitle: "No phrase to translate right now",
    emptyBody: "Come back later or pick another language.",
    doneDescription: "There is no phrase left to translate in this language for now. Thank you for your translations.",
    doneSent: "Translations sent",
    doneBack: "Back to the session",
    backToRecording: "Back to recording",
  },
} as const;

export type TranscriptionPhraseCopy = {
  [K in keyof (typeof transcriptionPhraseCopy)["fr"]]: K extends "instructions" ? readonly string[] : string;
};
